import { ArrowRight } from "lucide-react";

export const HubCard = ({ icon: Icon, title, subtitle, items = [], badge, onClick, index = 0 }) => (
  <button
    onClick={onClick}
    className="group text-left bg-white rounded-2xl p-7 border border-gray-100 shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:shadow-[0_16px_40px_rgb(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300 flex flex-col animate-fade-up h-full"
    style={{ animationDelay: `${Math.min(index, 8) * 55}ms` }}
    data-testid={`hub-card-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`}
  >
    <div className="flex items-center justify-between mb-5">
      <div className="w-12 h-12 rounded-xl bg-[#0F0F0F] text-[#D4AF37] flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
        <Icon size={22} strokeWidth={1.8} />
      </div>
      {badge && (
        <span className="text-[11px] font-semibold bg-[#F7F7F7] text-[#687280] px-2.5 py-1 rounded-full">
          {badge}
        </span>
      )}
    </div>

    <h3 className="font-display text-lg font-semibold text-[#0F0F0F]">{title}</h3>
    {subtitle && <p className="text-sm text-[#687280] mt-1 leading-relaxed">{subtitle}</p>}

    {items.length > 0 && (
      <div className="flex flex-wrap gap-2 mt-4">
        {items.map((it) => (
          <span
            key={it}
            className="text-xs font-medium px-3 py-1 rounded-full bg-[#F7F7F7] text-[#4B5563] border border-gray-100"
          >
            {it}
          </span>
        ))}
      </div>
    )}

    <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0F0F0F] group-hover:text-[#D4AF37] transition-colors">
      Open <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
    </span>
  </button>
);
